var Redux = require('redux');
var ReduxThunk = require("redux-thunk");
var ReactRouterRedux = require('react-router-redux');

var { routerReducer } = ReactRouterRedux;
var loadingReducer = require('../reducers/loading');
var loadingOrderReducer = require('../reducers/loadingOrder');
var authReducer = require('../reducers/auth');
var userReducer = require('../reducers/user');
var courierReducer = require('../reducers/courier');
var orderReducer = require('../reducers/order');
var myOrdersReducer = require('../reducers/myorders');
var specificOrderReducer = require('../reducers/specificOrder');
var settingReducer = require('../reducers/setting');

var Store = Redux.createStore(
	Redux.combineReducers({ 
		routing: routerReducer,
		auth: authReducer,
		users: userReducer,
		couriers: courierReducer,
		orders: orderReducer,
		myorders: myOrdersReducer,
		settings: settingReducer,
		loading: loadingReducer,
		loadingOrder: loadingOrderReducer,
		specificOrder: specificOrderReducer
	}),
	{},
	Redux.applyMiddleware(ReduxThunk.default)
);

module.exports = Store;


// WEBPACK FOOTER //
// ./src/store/index.js